<template>
  <div class="d-flex justify-content-between p-2 shadow-sm align-items-center">
    <span class="title-main fw-bold">ایران ترابر رانندگان</span>
    <img @click="backTell()" src="assets/svg/headset-outline.svg" data-bs-toggle="offcanvas"
      data-bs-target="#actionSheetShare" alt="headset" />
  </div>
  <div class="offcanvas offcanvas-bottom action-sheet inset" tabindex="-1" id="actionSheetShare">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title">پشتیبانی</h5>
      <a href="#" id="offTell" class="offcanvas-close" style="display: none" data-bs-dismiss="offcanvas">
        <ion-icon name="close-outline"></ion-icon>
      </a>
    </div>
    <div class="offcanvas-body" v-if="tel">
      <ul class="action-button-list">
        <li>
          <a @click="callSupport()" :href="'tel:' + tel" class="btn btn-list">
            <span>
              <ion-icon class="text-TEAL" name="call"></ion-icon>
              تماس
            </span>
          </a>
        </li>
        <li>
          <a href="https://www.goftino.com/c/vLBTmK" class="btn btn-list">
            <span>
              <ion-icon class="text-TEAL" name="chatbubbles"></ion-icon>
              گفتگو آنلاین
            </span>
          </a>
        </li>
        <li v-if="route.path !== '/login'">
          <router-link to="/support" class="btn btn-list">
            <span>
              <ion-icon class="text-TEAL" name="navigate"></ion-icon>
              ارسال تیکت
            </span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { useRoute } from 'vue-router';
export default {
  setup() {
    const route = useRoute();
    return { route };
  },
  data() {
    return {
      tel: window.localStorage.getItem("tel"),
      report: {
        type: 'Driver',
        load_id: this.loadId,
        owner_id: null,
      },
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      }
    };
  },
  mounted() {
    this.getTell();
  },
  methods: {
    callSupport() {
      axios.get("https://core.iran-tarabar.ir/api/driver/support", this.axiosConfig)
        .then((response) => {
          console.log(response);
        });
    },
    getTell() {
      axios.get("https://core.iran-tarabar.ir/api/getTel")
        .then((response) => {
          // this.$cookies.set("tel", { data: response.data.tel }, "1h");
          localStorage.setItem("tel", response.data.tel);
        });
    },
    backTell() {
      if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?backTell=1';
        window.history.pushState({ path: newurl }, '', newurl);
      }
    }
  },
}
</script>
<style></style>